import React from 'react';
import './App.css';

function App({ children }: any) {
  return (
    <div className="App">
        { children }
    </div>
  );
}

export default App;
